import { SprievodnyDokumentReportApi } from 'evidencna-aplikacia-frontend-ts-axios';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import apiConfiguration from '../../configuration/apiConfiguration';
import { ClientResponse } from '../../../model/ClientResponse';
import Uuid from '../../../model/Uuid';

const client = new SprievodnyDokumentReportApi(apiConfiguration(evidenciaPrefixPath));

export const createReportVyhodnotenieMpk = async (materialUuid: Uuid, stadiumUuid: Uuid, options?: object):
  Promise<ClientResponse<string>> => {
  const {
    data,
    status,
  } = await client.createReportVyhodnotenieMpk(materialUuid, stadiumUuid, options);

  return {
    data,
    responseCode: status,
  };
};

export const createReportVyjadrenie = async (
  materialUuid: Uuid,
  stadiumUuid: Uuid,
  options?: object,
):
  Promise<ClientResponse<ResponseType>> => {
  const {
    status,
  } = await client.createReportVyjadrenie(materialUuid, stadiumUuid, options);
  return {
    responseCode: status,
  };
};

export const createReportPripomienky = async (materialUuid: Uuid, stadiumUuid: Uuid, options?: object):
  Promise<ClientResponse<ResponseType>> => {
  const {
    status,
  } = await client.createReportPripomienky(materialUuid, stadiumUuid, options);

  return {
    responseCode: status,
  };
};
